import { STORE_TASKPDF_CHAT_HISTORY, TASKPDF_CHECK_API, TASKPDF_HANDLE_STRING, DOCKER_STATUS_CHECK_TASKPDF } from '../../common/actionTypes';
const INITIAL_STATE = {
  taskpdf_chat_chatbot: {},
  check_api: false,
  handle_string: false,
  dockerStatus: false,
};

const taskpdfReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case STORE_TASKPDF_CHAT_HISTORY: {
      return { ...state, taskpdf_chat_chatbot: action.payload };
    }
    case TASKPDF_CHECK_API: {
      return { ...state, check_api: action.payload };
    }
    case TASKPDF_HANDLE_STRING: {
      return { ...state, handle_string: action.payload };
    }
    case DOCKER_STATUS_CHECK_TASKPDF: {
      return { ...state, dockerStatus: action.payload };
    }
    default:
      return state;
  }
};

export default taskpdfReducer;
